import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import '../../Components/report.css';
import Response from '../../Components/Response/Teacher';
import { Link } from 'react-router-dom';

function TeacherReviewEvaluations(props) {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const mappedQuestionsAndAnswers = () => {
        const questionAnswers = props.sprint.questionAnswerTypePairs.filter(question => question.answer !== "Text");
        const questionAnswerArray = []
        let questionAnswer;

        for (let i = 0; i < questionAnswers.length; i++) {
            questionAnswer = questionAnswers[i];
            questionAnswerArray.push({question: questionAnswer.question, answers: [], answerType: questionAnswer.answer, yValues: {1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0}, yesNo: {"classYes": 0, "classNo": 0, "studentYes": 0, "studentNo": 0}, classAnswers: []})
        }

        for (let i = 0; i < props.sprintEvaluations.length; i++) {
            const { questionAnswerPairs = [] } = props.sprintEvaluations[i];
            for (let j = 0; j < questionAnswerArray.length; j++) {
                if (questionAnswerArray[j].answerType === "Y/N" && questionAnswerPairs[j]) {
                    questionAnswerArray[j].yesNo[
                        `student${questionAnswerPairs[j].answer}`
                    ] += 1;
                } else if (
                    questionAnswerPairs[j] &&
                    questionAnswerPairs[j].answer
                ) {
                questionAnswerArray[j].answers.push(
                    questionAnswerPairs[j].answer
                );
                }
            }
        }

        let response;
        const createMatchingQuestionFinder = questionAnswer => {
            return entry => entry.question === questionAnswer.question;
        };
        let questionFinder;
        for (let i = 0; i < questionAnswerArray.length; i++) {
            questionAnswer = questionAnswerArray[i];
            questionFinder = createMatchingQuestionFinder(questionAnswer);
            for (let evaluation of props.sprintEvaluations) {
                const found = evaluation.questionAnswerPairs.find(questionFinder)
                if(found) {
                    if (questionAnswer.answerType === "Range") {
                        response = parseInt(found.answer, 10);
                        questionAnswer.classAnswers.push(response)
                        questionAnswer.yValues[response] += 1
                    } else if (questionAnswer.answerType === "Y/N") {
                        response = found.answer;
                        questionAnswer.yesNo[`class${response}`] += 1
                    }
                }
            }
        }

        return questionAnswerArray.map((questionAnswer, index) => {
            return <Response
                       questionAnswer={questionAnswer}
                       index={index}
                       key={index + "questionAnswer"}
                   />
        });
    }

    if (!props.sprint || !props.sprint.questionAnswerTypePairs) {
        return (
            <div className="reportPage">
                <div className="backButton">
                    <Link to="/teacher">
                        <img src={require("../../../Images/leftArrow.png")} alt="<-"/>
                        Return to Dashboard
                    </Link>
                </div>
                <p>No sprint selected. Please return to the dashboard and select a sprint.</p>
            </div>
        );
    }

    return (
        <div className="reportPage">
            <div className="backButton">
                <Link to="/teacher">
                    <img src={require("../../../Images/leftArrow.png")} alt="<-"/>
                    Return to Dashboard
                </Link>
            </div>
            <div className="responsesWrapper">
                <h1>Class Responses</h1>
                {mappedQuestionsAndAnswers()}
            </div>
        </div>
    );
}

export default connect(state => state.root, {})(TeacherReviewEvaluations);
